import {
  AuthFormBoxInternalTemplate,
  PhoneNumberInputBlock,
  PrimarySubmitButton,
} from '@setplex/arcana'
import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { useCallback, type ChangeEvent, type FormEvent } from 'react'
import { $signUpFormTranslations } from '../../translations'
import { signUpByPhoneForm, signUpByPhoneFx } from '../model'

export const RegistrationByPhoneForm = (): JSX.Element => {
  const formTranslations = useUnit($signUpFormTranslations)

  const { submit, eachValid, fields, errorText, hasError } =
    useForm(signUpByPhoneForm)

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    submit()
  }

  const getErrorMessage = (type: Parameters<typeof errorText>[0]): string => {
    const text = errorText(type, formTranslations[type].errors)
    return hasError(type) ? text : ''
  }

  const pending = useUnit(signUpByPhoneFx.pending)
  const validatePhone = (phone: string): boolean => /^\+?\d*$/.test(phone)
  const handleChangePhone = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      validatePhone(e.target.value) && // do not allow to type anything except numbers
      fields.phoneNumber.onChange(e.target.value),
    [fields.phoneNumber]
  )

  return (
    <form onSubmit={onSubmit} autoComplete='off' noValidate>
      <AuthFormBoxInternalTemplate>
        <PhoneNumberInputBlock
          label={formTranslations.phoneNumber.label}
          value={fields.phoneNumber.value}
          onChange={handleChangePhone}
          onBlur={() => fields.phoneNumber.onBlur()}
          disabled={pending}
          errorMessage={getErrorMessage('phoneNumber')}
          autoComplete='one-time-code'
        />
        <PrimarySubmitButton
          title={formTranslations.submitButton}
          disabled={pending || !eachValid}
          isLoading={pending}
        />
      </AuthFormBoxInternalTemplate>
    </form>
  )
}
